var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-h3 accent--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm.tag.substr(0, 3))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.tag.substr(3, 5))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }